import React from "react";
import PropTypes from "prop-types";
import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem as DropDownItem
} from "MODULES/shared/components/DropDown";
import { deleteOutgoingQuoteLineItem } from "MODULES/OutgoingQuotes/actions";
import ConfirmDelete from "MODULES/shared/components/ConfirmDelete";
import { connect } from "react-redux";

function Controls({ deleteItem }) {
  return (
    <DropDown>
      <DropDownItem
        id="delete"
        label="Delete"
        faIcon="ban"
        renderActive={<ConfirmDelete onConfirm={deleteItem} />}
      />
    </DropDown>
  );
}

Controls.propTypes = {
  deleteItem: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, { lineItem: { id } }) => ({
  deleteItem: () => dispatch(deleteOutgoingQuoteLineItem(id))
}))(Controls);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/LineItems/Controls.jsx